const PowerPointFileIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 34 16" aria-hidden="true" className={className}>
    <text
      x="17"
      y="8"
      fill="currentColor"
      fontSize="10"
      fontWeight="700"
      fontFamily="Arial, sans-serif"
      textAnchor="middle"
      dominantBaseline="middle"
    >
      PPT
    </text>
  </svg>
)

export default PowerPointFileIcon
